import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  startDateTitle: {
    id: 'course-authoring.course-outline.status-bar.start-date',
    defaultMessage: 'Start date',
  },
  pacingTypeTitle: {
    id: 'course-authoring.course-outline.status-bar.pacing-type',
    defaultMessage: 'Pacing type',
  },
  pacingTypeSelfPaced: {
    id: 'course-authoring.course-outline.status-bar.pacing-type.self-paced',
    defaultMessage: 'Self-paced',
  },
  pacingTypeInstructorPaced: {
    id: 'course-authoring.course-outline.status-bar.pacing-type.instructor-Paced',
    defaultMessage: 'Instructor-paced',
  },
  checklistTitle: {
    id: 'course-authoring.course-outline.status-bar.checklists',
    defaultMessage: 'Checklists',
  },
  checklistCompleted: {
    id: 'course-authoring.course-outline.status-bar.checklists.completed',
    defaultMessage: 'completed',
  },
  highlightEmailsTitle: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails',
    defaultMessage: 'Course highlight emails',
  },
  highlightEmailsButton: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails.button',
    defaultMessage: 'Enable now',
  },
  highlightEmailsEnabled: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails.enabled',
    defaultMessage: 'Enabled',
  },
  highlightEmailsLink: {
    id: 'course-authoring.course-outline.status-bar.highlight-emails.link',
    defaultMessage: 'Learn more',
  },
  courseTagsTitle: {
    id: 'course-authoring.course-outline.status-bar.course-tags',
    defaultMessage: 'Course tags',
    description: 'Course tags header in course outline',
  },
  courseManageTagsLink: {
    id: 'course-authoring.course-outline.status-bar.course-manage-tags-link',
    defaultMessage: 'Manage tags',
    description: 'Opens the drawer to edit content tags',
  },
  videoSharingTitle: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.title',
    defaultMessage: 'Video Sharing',
  },
  videoSharingLink: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.link',
    defaultMessage: 'Learn more',
  },
  videoSharingPerVideoText: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.perVideo.text',
    defaultMessage: 'Per Video',
  },
  videoSharingAllOffText: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.allOff.text',
    defaultMessage: 'No Videos',
  },
  videoSharingAllOnText: {
    id: 'course-authoring.course-outline.status-bar.video-sharing.allOn.text',
    defaultMessage: 'All Videos',
  },
});

export default messages;
